import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { EmojiChar, EmojiGroup, emojiGroups$ } from '../../htmlEditor/EmojiData';
import { BaseControlValueAccessor } from '../../util/BaseControlValueAccessor';


@Component({
	selector: 'emoji-picker',
	templateUrl: './EmojiPicker.Component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => EmojiPickerComponent),
		multi: true
	}],
	imports: [
		CommonModule,
		FormsModule,
		BsDropdownModule,
		TooltipModule,
		TranslateModule
	],
	styleUrls: ['./EmojiPicker.ng.less']
})
export class EmojiPickerComponent extends BaseControlValueAccessor<EmojiChar[]> implements OnInit {
	@Input() public maxLength: number = 0;
	public emojiGroups: EmojiGroup[];
	public selectedGroup: EmojiGroup;

	public filter: string;
	public filteredEmojis: EmojiChar[];

	public ngOnInit(): void {
		emojiGroups$.then(groups => {
			this.emojiGroups = groups;
			this.selectedGroup = groups[0];
		});
	}

	public addEmoji(emoji: EmojiChar): void {
		if (this.value.length < this.maxLength &&
			this.value.every(e => e.char !== emoji.char)) {
			this.updateModelValue([...this.value, emoji]);
		}
	}

	public removeEmoji(index: number): void {
		this.updateModelValue(this.value.filter((_, i) => i !== index));
	}
}
